module.exports = __webpack_public_path__ + "static/media/dublin-bus.885dabf5.jpg";